import LanguageSelector from "./languageSelector.component";

const LanguageSelectorSidebar = () => {
    return (
        <LanguageSelector
            layout="list"
            variant="small"
        />
    );
};

export { LanguageSelectorSidebar };
